import { LoginPage } from '@radoccpages/login/panel-login/login.page';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PainelSiteComponent } from './componentes/layouts/painel-site/painel-site.component';

const routes: Routes = [
  {
    path:'',
    redirectTo:'login',
    pathMatch:'full'
  },
   {
     path:'login',
     loadChildren: () => import('@radoccpages/login/login.module').then(m => m.LoginModule)
   },
   {
    path:'redefinir-senha/:token',
    loadChildren: () => import('@radoccpages/redefinir/redefinir-senha.module').then(m => m.RedefinirModule)
  },
  {
    path:'admin',
    component:PainelSiteComponent,
    children:[
      {
        path:'conteudo',
        loadChildren: () => import('@radoccpages/conteudo/conteudo.module').then(m => m.ConteudoModule)
      },
      {
        path:'publicacao',        
        loadChildren: () => import('@radoccpages/publicacao/publicacao.module').then(m => m.PublicacaoModule)
      },
      {
        path:'player',
        loadChildren: () => import('@radoccpages/player/player.module').then(m => m.PlayerModule)
      }, 
      {
        path:'playlist',
        loadChildren: () => import('@radoccpages/playlist/playlist.module').then(m => m.PlaylistModule)
      }, 
      {
        path:'grupoplayer',
        loadChildren: () => import('@radoccpages/grupoplayer/grupoplayer.module').then(m => m.GrupoPlayerModule)
      }, 
      {
        path:'relatorio',
        loadChildren: () => import('@radoccpages/relatorio/relatorio.module').then(m => m.RelatorioModule)
      },
      {
        path:'configuracao',
        loadChildren: () => import('@radoccpages/configuracao/configuracao.module').then(m => m.ConfiguracaoModule)
      },
      {
        path:'ajuda',
        loadChildren: () => import('@radoccpages/ajuda/ajuda.module').then(m => m.AjudaModule)
      }
    ] 
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
